const FILE_EXTENSION_REGEX = /\.[^/.]+$/;
const PNG_MIME_TYPE = 'image/png';

export const convertWebPToPng = async (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      // Create canvas
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      // Draw image on canvas
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Failed to get canvas context'));
        return;
      }
      ctx.drawImage(img, 0, 0);

      // Convert to PNG
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Failed to convert image'));
          return;
        }
        // Create new file with PNG extension
        const convertedFile = new File(
          [blob],
          file.name.replace(FILE_EXTENSION_REGEX, '.png'),
          {
            type: PNG_MIME_TYPE,
          },
        );
        resolve(convertedFile);
      }, PNG_MIME_TYPE);
    };

    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = URL.createObjectURL(file);
  });
};
